/* eslint-disable import/prefer-default-export */

export const loadStatuses = {
  STALE: 0,
  LOADING: 1,
  SUCCESS: 2,
  FAILED: 3,
};
